import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTwoUsersNavFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 33,
	viewBox: "0 0 41 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.5 9C6.5 6.1875 8 3.5625 10.5 2.125C12.9375 0.6875 16 0.6875 18.5 2.125C20.9375 3.5625 22.5 6.1875 22.5 9C22.5 11.875 20.9375 14.5 18.5 15.9375C16 17.375 12.9375 17.375 10.5 15.9375C8 14.5 6.5 11.875 6.5 9ZM0.5 31.1875C0.5 25 5.4375 20 11.625 20H17.3125C23.5 20 28.5 25 28.5 31.1875C28.5 32.1875 27.625 33 26.625 33H2.3125C1.3125 33 0.5 32.1875 0.5 31.1875ZM38.5625 33H29.9375C30.25 32.4375 30.5 31.75 30.5 31V30.5C30.5 26.75 28.75 23.3125 26.125 21.0625C26.25 21.0625 26.375 21 26.5625 21H30.375C35.9375 21 40.5 25.5625 40.5 31.125C40.5 32.1875 39.625 33 38.5625 33ZM27.5 17C25.5625 17 23.8125 16.25 22.5 15C23.75 13.3125 24.5 11.25 24.5 9C24.5 7.375 24.0625 5.75 23.3125 4.375C24.5 3.5625 25.9375 3 27.5 3C31.3125 3 34.5 6.1875 34.5 10C34.5 13.875 31.3125 17 27.5 17Z",
		fill: "#D9D9D9"
	})]
});
const ForwardRef = forwardRef(SvgIconTwoUsersNavFilled);
export { ForwardRef as ReactComponent };
